import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "max-h-fit app-footer" }
const _hoisted_2 = { class: "footer-icons" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "newsletter" }
const _hoisted_5 = { class: "micro-links" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "copyright" }

import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';
import {
  faInstagram,
  faYoutube,
  faFacebook,
  faMedium
} from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
//import { faEnvelope } from '@fortawesome/pro-light-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'SiteFooter',
  setup(__props) {

const email = ref('');
const submitEmail = () => {
  if (email.value) {
    alert(`Thanks for subscribing, ${email.value}!`);
    email.value = '';
  }
};

// Font Awesome Icons
const socialIcons = [
  { name: 'instagram', icon: faInstagram, link: 'https://www.instagram.com/valvevista' },
  { name: 'youtube', icon: faYoutube, link: 'https://www.youtube.com/@valvevista' },
  { name: 'facebook', icon: faFacebook, link: 'https://www.facebook.com/valvevista/' },
  { name: 'medium', icon: faMedium, link: 'https://medium.com/@valvevista' },
];

// Micro links
const microLinks = [
  { text: 'Terms of Service', href: '#' },
  { text: 'Privacy Policy', href: '#' },
  { text: 'Warranty', href: '#' }
];

// Animate glow + pulse on hover
/*
const onIconHover = (e: any) => {
  gsap.to(e.currentTarget, {
    scale: 1.2,
    boxShadow: '0 0 10px #ff9f1c',
    duration: 0.3,
    ease: 'power2.out'
  });
};

const onIconLeave = (e: any) => {
  gsap.to(e.currentTarget, {
    scale: 1,
    boxShadow: '0 0 0px transparent',
    duration: 0.2
  });
};
 */

// Flickering glow text
const copyrightText = ref(null);

onMounted(() => {
  const flicker = () => {
    gsap.to(copyrightText.value, {
      opacity: gsap.utils.random(0.8, 1),
      duration: gsap.utils.random(0.1, 0.3),
      repeat: -1,
      yoyo: true,
      ease: 'none'
    });
  };
  flicker();
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialIcons, (icon) => {
            return _createElementVNode("a", {
              key: icon.name,
              class: "social-icon",
              href: icon.link
            }, [
              (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                key: icon.name,
                icon: icon.icon
              }, null, 8, ["icon"]))
            ], 8, _hoisted_3)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { for: "email" }, "Join Mailing List:", -1)),
          _createVNode(_component_v_text_field, {
            class: "text-gray-500",
            id: "email",
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            placeholder: "Enter your email",
            "hide-details": "",
            solo: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_btn, {
            class: "join-btn",
            onClick: submitEmail
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Join", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(microLinks, (link) => {
            return _createElementVNode("a", {
              key: link.text,
              href: link.href
            }, _toDisplayString(link.text), 9, _hoisted_6)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            ref_key: "copyrightText",
            ref: copyrightText
          }, "© 2025 Valve Vista Sound Labs – Warming the World, One Tube at a Time", 512)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})